<template>
  <div>
    <span class="titlemenu mt-4">猜你喜欢</span
    ><span class="title-append"> 建议添加2~3个商品，商品可以拖动排序 </span>
    <div style="margin-top: 1rem; margin: 2rem 0">
      <el-button
        @click="addFormVisible = true"
        type="plain"
        size="mini"
        icon="el-icon-plus"
        >商品</el-button
      >
    </div>
    <el-empty v-show="isShow" description="暂无数据"></el-empty>
    <div id="good_box">
      <draggable
        style="display: flex; flex-wrap: wrap"
        v-model="titleList"
        @update="datadragEnd"
        :options="{ animation: 500 }"
      >
        <transition-group name="myfade">
          <good-item
            @deleteD="deleteD"
            style="
              margin-right: 2rem;
              margin-bottom: 2rem;
              display: inline-block;
            "
            v-for="(item, index) in titleList"
            :key="item.id"
            :value="item"
        /></transition-group>
      </draggable>
    </div>

    <!--  <div id="drag">
      <div class="goods"  v-for="(item, index) in list"
      :value="item"
      :key="item.id"
      :title="titleList[index].title"
      @changeText="changeText"></div>
    </div> -->
    <el-dialog
      :title="'添加'"
      :visible.sync="addFormVisible"
      width="60%"
      left
      :close-on-click-modal="false"
    >
      <el-form :label-width="formLabelWidth">
        <el-row :span="24">
          <el-col :sm="5" :md="5" :lg="8">
            <el-form-item label="所属科目" label-width="80px" prop="pid">
              <el-cascader
                v-model="searchForm.subjectIds"
                :show-all-levels="false"
                ref="tree"
                collapse-tags
                :options="subjectTreeList"
                :props="subjectTreeProps"
                clearable
              ></el-cascader>
            </el-form-item>
          </el-col>

          <el-col :sm="8" :md="8" :lg="8">
            <el-form-item label="商品名称">
              <el-input v-model="searchForm.name"></el-input>
            </el-form-item>
          </el-col>

          <el-col :sm="5" :md="5" :lg="5" style="margin-left: 10px">
            <el-button type="primary" @click="getList()">查询</el-button>
          </el-col>
        </el-row>
        <el-button type="primary" @click="clickGoods">确认选择</el-button>
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-table
              :data="tableList"
              tooltip-effect="dark"
              ref="tableref"
              style="width: 100%"
              highlight-current-row
              @current-change="selectionChange"
              border
              v-loading="loading1"
              element-loading-text="拼命加载中"
              element-loading-background="rgba(255, 255, 255, 0.8)"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column
                prop="subjectCourseName"
                show-overflow-tooltip
                label="商品详情"
              >
                <template slot-scope="row">
                  <el-row>
                    <el-col :span="8">
                      <span>
                        <img
                          style="margin-right: 10px"
                          width="100%"
                          height="44px"
                          :src="
                            row.row.logo
                              ? row.row.logo
                              : '../../../static/image/noImg.png'
                          "
                        />
                      </span>
                    </el-col>
                    <el-col :span="16">
                      <span
                        style="color: rgb(77, 148, 255); margin-left: 10px"
                        >{{ row.row.name }}</span
                      >
                      <span style="display: block; margin-left: 10px">
                        <span style="color: red">￥{{ row.row.price }}</span>
                        <span
                          style="
                            text-decoration: line-through;
                            color: rgb(162, 170, 188);
                          "
                          >￥{{ row.row.originalPrice }}</span
                        >
                      </span>
                    </el-col>
                  </el-row>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                width="200"
                prop="name"
                label="商品名称"
              >
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="snapPrice"
                width="100"
                label="售价"
              >
                <template slot-scope="row">
                  <span>{{ row.row.snapPrice }}元</span>
                </template></el-table-column
              >

              <el-table-column
                show-overflow-tooltip
                width="100"
                prop="validDay"
                label="有效期"
              >
                <template slot-scope="row">
                  <span>{{ row.row.validDay }}天</span>
                </template></el-table-column
              >
              <el-table-column
                show-overflow-tooltip
                width="200"
                prop="subjectCourseName"
                label="商品类型"
              ></el-table-column>
              <!--  <el-table-column
                show-overflow-tooltip
                width="200"
                prop="subjectCourseName"
                label="商品内容"
              ></el-table-column> -->
            </el-table>
            <el-pagination
              background
              layout="total, prev, pager, next"
              style="margin-top: 20px; text-align: right"
              :total="page.total"
              :page-size="page.pageSize"
              :current-page="page.pageNumber"
              @size-change="sizeChange"
              @current-change="currentChange"
            ></el-pagination>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <!--  <el-button type="primary" @click="closeDialog">确 定</el-button> -->
      </div>
    </el-dialog>
    <div style="margin: 2rem 0"></div>
    <Confirm @savePage="saveData" />
  </div>
</template>

<script>
//import drawerDetail from "@/components/drawerDetail.vue";
import draggable from "vuedraggable";
import { mapGetters } from "vuex";
import ue2 from "@/components/common/UE2.vue";
import RichText from "../components/RichText.vue";
import Confirm from "../components/Confirm.vue";
import GoodItem from "../components/GoodItem.vue";
import commonMixin from "../mixin/index.js";
export default {
  components: { draggable, ue2, RichText, Confirm, GoodItem },
  mixins: [commonMixin],
  props: {
    com: {
      tyoe: String,
      default: "",
    },
    /*  value: {
      tyoe: Object,
      default: {},
    }, */
  },
  data() {
    return {
      titleList: [],
      /*  titleList: [
        {
          id: 12,
          price: 200,
          src: "https://68wx--test.oss-cn-hangzhou.aliyuncs.com/image/16359239874637.jpg",
          num: 100,
          name: "商品测试6",
        },
        {
          id: 32,
          price: 200,
          src: "https://68wx--test.oss-cn-hangzhou.aliyuncs.com/image/16359239874637.jpg",
          num: 100,
          name: "商品名5",
        },
        {
          id: 332,
          price: 200,
          src: "https://68wx--test.oss-cn-hangzhou.aliyuncs.com/image/16359239874637.jpg",
          num: 100,
          name: "商品名4",
        },
        {
          id: 324,
          price: 200,
          src: "https://68wx--test.oss-cn-hangzhou.aliyuncs.com/image/16359239874637.jpg",
          num: 100,
          name: "商品名3",
        },
        {
          id: 362,
          price: 200,
          src: "https://68wx--test.oss-cn-hangzhou.aliyuncs.com/image/16359239874637.jpg",
          num: 100,
          name: "商品名2",
        },
        {
          id: 329,
          price: 200,
          src: "https://68wx--test.oss-cn-hangzhou.aliyuncs.com/image/16359239874637.jpg",
          num: 100,
          name: "商品名1",
        },
      ], */
      list: [
        { id: 1, value: 1, title: "准考证打印时间", appendTitle: "" },
        {
          id: 2,
          value: 3,
          title: "准考证打印方法",
          appendTitle: "通过这门考试的科目，科目可以拖动排序",
        },
      ],

      editForm: {},
      searchForm: { subjectIds: [], name: "" },
      visible: false,
      courseIds: [],
      subjectTreeList: [], //科目
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
        expandTrigger: "hover",
        multiple: true,
      },
      formLabelWidth: "80px",
      checkList: [],
      loading1: false,
      tableList: [],
      arrsSelect: [],
      addFormVisible: false,
      activeObjectType: "商品",
      total: 0,
      page: {
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
    };
  },
  methods: {
    datadragEnd() {
      console.log("拖拽完成");
    },
    deleteD(id) {
      const index = this.titleList.findIndex((obj) => obj.id === id);
      this.titleList.splice(index, 1);
      /*  this.list = this.titleList.map((obj) => ({
        id: obj.id,
        content: obj.name,
      }));
      console.log(this.list, "list");
      //debugger;
      this.savePage(); */
    },
    clickGoods() {
      if (!Array.isArray(this.titleList)) {
        this.titleList = [];
      }
      const list = this.titleList.map((item) => item.id);
      console.log(this.arrsSelect);
      this.arrsSelect.forEach((item) => {
        if (!list.includes(item.id)) {
          this.titleList.push(item);
        }
      });
      // this.titleList = [...this.titleList, ...this.arrsSelect];
      this.addFormVisible = false;
      this.$refs.tableref.clearSelection();
      //this.list = [...new Set([...this.list, ...this.arrsSelect])];
    },
    handleSelectionChange(val) {
      this.arrsSelect = val;
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.getList();
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.getList();
    },

    closeDialog() {
      console.log("点击了确定");
    },
    addGoodsAgentPrice() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.api.goodsInfo.updateGoodsInfo(this.editForm).then((result) => {
            if (result.success) {
              this.$message.success(result.message);
              this.agentPriceVisible = false;
              this.editForm = {};
              this.pageList();
            } else {
              this.$message.error(result.message);
            }
          });
        }
      });
    },
    selectionChange(val) {
      this.checkList = val;
    },
    getList() {
      this.loading1 = true;
      let arr = [];
      if (this.searchForm.subjectIds.length > 0) {
        this.searchForm.subjectIds.forEach((item) => {
          arr.push(item[1]);
        });
        console.log("arrr", arr, this.searchForm.subjectIds);
      }
      let obj = {
        pageSize: this.page.pageSize,
        pageNumber: this.page.pageNumber,
        sortName: this.page.sortName,
        sortOrder: this.page.sortOrder,
        agentId: this.loginData.agentId,
        flashSaleType: this.searchForm.flashSaleType,
        name: this.searchForm.name,
        subjectIds: arr,
      };
      let requestUrl = "pageList";
      /*  if (this.activeObjectType == "政策") {
        requestUrl = "pageListPolicy";
      } else if (this.activeObjectType == "资讯") {
        requestUrl = "pageListInformation";
      } else if (this.activeObjectType == "机构") {
        requestUrl = "pageListCampus";
      } */

      this.api.goodsInfo[requestUrl](obj)
        .then((result) => {
          this.loading1 = false;
          this.tableList = result.data.records;
          this.page.total = result.data.total;
          this.arrsSelect = [];
        })

        .catch((error) => {
          console.log(error);
        });
    },
    getSubjectTreeList() {
      // 获取课程
      this.api.campus
        .getPermissionSubjectTree()
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                delete items.children;

                // if (items.children.length != 0) {
                //   for (let itemss of items.children) {
                //     delete itemss.children;
                //   }
                // } else {
                //   // delete items.children;
                // }
              }
            } else {
              // delete item.children;
            }
          }

          this.subjectTreeList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    changeDisable(arr) {
      if (arr && arr.length > 0) {
        arr.forEach((item) => {
          item.disabled = false;
          this.changeDisable(item.children);
        });
        return arr;
      } else {
        return [];
      }
    },
  },
  computed: {
    ...mapGetters(["loginData"]),
  },
  watch: {
    value: {
      handler(val) {
        //  debugger;
        //console.log("监听");
        //console.log("传值改变了", val);
        const list = val.subjectGuideItemDetails || [];
        this.list = list;
        this.titleList = list.map((obj) => obj.goodsInfo);
      },
      deep: true,
      immediate: true,
    },
    titleList: {
      handler(val) {
        this.list = val.map((obj) => ({
          title: "商品",
          content: obj.id,
        }));
        console.log("商品", this.titleList);
        this.savePage();
      },
      deep: true,
      immediate: true,
    },
    "searchForm.subjectIds": {
      handler(val) {
        console.log("val11", val);
      },
      deep: true,
    },
  },
  created() {
    console.log("初始化了", this.list);
    this.getSubjectTreeList();
    this.getList();
  },
  mounted() {
    /* window.onresize = () => {
      this.setaddDialogwidth();
    }; */
  },
};
</script>
<style scoped>
.myfade-enter-active,
.myfade-leave-active {
  transition: all 0.2s ease-out;
}
/* 进场的瞬间与离场的效果添加 */
.myfade-enter,
.myfade-leave-to {
  opacity: 0;
  transform: translateY(200px);
}
.titlemenu {
  font-weight: 600;
  font-size: 16px;
}
.title-append {
  margin-left: 1rem;
  color: #a5a5a5;
}
.mt-4 {
  margin-top: 1rem;
}
.i-icon {
  font-size: 16px;
  display: inline-block;
  color: #66b1ff;
  cursor: pointer;
}
.sidebar {
  width: 245px !important;
  border-radius: 4px;
  overflow: auto;
  background: #fff;
}
.sidebarRight {
  padding: 0px 20px !important;
}

.sidebar .title,
.sidebarRight .title {
  height: 50px;
  line-height: 50px;
  padding-left: 20px;
  border-bottom: 1px solid #e5ecf0;
}

.sidebarRight .search {
  background: #66b1ff !important;
  border: 0;
  outline: none;
  border-radius: 0;
  height: 40px;
  color: white !important;
}

.classManger .caret-wrapper {
  position: absolute;
  right: 0;
  top: -5px;
}
.table_bottom {
  margin: 20px 0;
}
.left-top-bottom {
  float: right;
  color: #4d94ff;
  font-weight: 600;
  margin-left: 10px;
  margin-top: 2px;
}
.campusManage-search {
  padding: 0px 10px;
}
.campusManage-tree {
  margin-top: 10px;
}
.span-ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/addGuide/module/guessYouLike.vue